
class ButtonActionHelper {

    /**
     * Takes an array of actions and excutes a handler for each action.
     * @param actions The actions of that particular button.
     * @param state2 The state passed from a state container used for global state.
     * @param eventType Type of event where the action is being called.
     */
    executeActions(actions, state2, eventType) {
        actions.forEach(action => {
            this.actionHandler(action, state2, eventType)
        })
    }

    /**
     * Executes an action depending on its properties and passed parameters.
     * @param action The action of that particular button.
     * @param state2 The state passed from a state container used for global state.
     * @param actionType Type of event where the action is being called.
     */
    actionHandler(action, state2, eventType) {
        if (eventType !== action.eventName) return

        //Handles change state actions
        if (action.element === "stateView" && action.functionName === "showElement") {
            state2.updateCurrentFloorByButton(action.parameter)
            return
        }

        //Goes to url passed as the action parameter
        if (action.functionName === "goToUrl") {
            window.location = action.parameter;

        }

        //handles pan actions
        if (action.functionName.substring(0, 3) === "pan") {
            state2[action.functionName]()
        }

        //handles toggling display of elements
        if (action.functionName === "showElement") {
            state2.handleShowElement(action.element, true)
        }
        if (action.functionName === "hideElement") {
            state2.handleShowElement(action.element, false)
        }

        if (action.functionName === "toggleFullscreen")
            state2.toggleFullscreen()

        return
    }
}

export default new ButtonActionHelper()